{
  "modal": {
    "buttonLabel": "Choose a new time",
    "text": "Someone else has just booked that time.",
    "title": "Just missed it!"
  },
  "nextLabel": "$t(common:next): <b>Reserve appointment time</b>",
  "nextWeek": "Next week",
  "noTimeText": "There are no times available for the selected date.",
  "prevWeek": "Prev week",
  "title": "Choose your appointment time"
}
